import { Navigate, Outlet } from "react-router"

import { PRODUCTS_HOME_PATH } from "@/lib/post-auth-landing"
import { canAccessAdminConsole } from "@/lib/workspace-role"

export function RequireWorkspaceAdmin() {
  if (!canAccessAdminConsole()) return <Navigate to={PRODUCTS_HOME_PATH} replace />
  return <Outlet />
}
